export enum BetSlipStatus {
	PAID_OUT = "paid-out",
	CASHOUT = "cashout",
	SUBMITTED = "submitted",
	WON = "won",
	LOST = "lost",
	FOR_PAYOUT = "for-payout",
}
